import { render, staticRenderFns } from "./InputOtpToken.vue?vue&type=template&id=b7b27480&scoped=true&"
import script from "./InputOtpToken.vue?vue&type=script&lang=js&"
export * from "./InputOtpToken.vue?vue&type=script&lang=js&"
import style0 from "./InputOtpToken.vue?vue&type=style&index=0&id=b7b27480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b27480",
  null
  
)

export default component.exports